define('models/environment',["require", "exports"], function (require, exports) {
    "use strict";
    var Configuration = (function () {
        function Configuration(data) {
            this._data = data;
        }
        Object.defineProperty(Configuration.prototype, "userManager", {
            get: function () {
                return this._data.userManager;
            },
            enumerable: true,
            configurable: true
        });
        ;
        Object.defineProperty(Configuration.prototype, "chat", {
            get: function () {
                return this._data.chat;
            },
            enumerable: true,
            configurable: true
        });
        ;
        Object.defineProperty(Configuration.prototype, "leftPanels", {
            get: function () {
                return this._data.leftPanels;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Configuration.prototype, "rightPanels", {
            get: function () {
                return this._data.rightPanels;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Configuration.prototype, "initializers", {
            get: function () {
                return this._data.initializers;
            },
            enumerable: true,
            configurable: true
        });
        Configuration.prototype.getCustomValue = function (key, defaultValue) {
            if (defaultValue === void 0) { defaultValue = null; }
            var keyValue = null;
            if (Array.isArray(this._data.custom)) {
                var foundKeys = this._data.custom.filter(function (param) { return param.key === key; });
                if (foundKeys.length === 1) {
                    keyValue = foundKeys[0].value;
                }
                else
                    keyValue = defaultValue;
            }
            return keyValue;
        };
        return Configuration;
    }());
    exports.Configuration = Configuration;
    var UserManager = (function () {
        function UserManager() {
        }
        return UserManager;
    }());
    exports.UserManager = UserManager;
    var Chat = (function () {
        function Chat() {
        }
        return Chat;
    }());
    exports.Chat = Chat;
    var ExtenderPanel = (function () {
        function ExtenderPanel() {
        }
        return ExtenderPanel;
    }());
    exports.ExtenderPanel = ExtenderPanel;
    var Initializer = (function () {
        function Initializer() {
        }
        return Initializer;
    }());
    exports.Initializer = Initializer;
    var KeyValuePair = (function () {
        function KeyValuePair() {
        }
        return KeyValuePair;
    }());
    exports.KeyValuePair = KeyValuePair;
});

